import styled, { css } from 'styled-components';

const overTwoTitleStyles = css`
  @media (min-width: 576px) {
    .arrow-down {
      display: none;
    }

    .toggle--toggle {
      width: 33.33% !important;
    }

    &.active-1 {
      .toggle--toggle {
        left: 33.33% !important;
      }
    }

    &.active-2 {
      .toggle--toggle {
        left: calc(66.66% - 6px);
      }
    }
  }

  @media (max-width: 575px) {
    .arrow-down {
      svg {
        width: 20px;
        height: 20px;
        display: block;
      }
    }
    .toggle--title {
      height: 70px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    label .toggle--toggle {
      width: 33.33%;
      height: 60px !important;
      left: 6px !important;
    }

    .toggle--titles {
      flex-direction: column;
    }

    .toggle--title-container,
    .toggle--toggle {
      width: calc(100% - 12px) !important;
    }

    &.animate {
      label .toggle--toggle {
        transition: all 0.5s ease !important;
      }
    }

    label .toggle--toggle {
      transition: none !important;
    }

    &.open {
      height: 100% !important;

      &.active-1 {
        .toggle--toggle {
          top: calc(50% - 31px);
        }
      }

      &.active-2 {
        .toggle--toggle {
          top: calc(100% - 65px);
        }
      }
    }

    &.closed {
      .inactive {
        display: none;
      }

      .toggle--title-container {
        position: relative;

        &:after {
          content: '';
          position: absolute;
          right: 10px;
          z-index: 5;
          width: 0;
          height: 0;
          border-left: 6px solid transparent;
          border-right: 6px solid transparent;
          border-top: 6px solid #637984;
        }
      }
    }
  }
`;

const ToggleSwitchContainer = styled.div`
  ${({ twoItemToggle }) => !twoItemToggle && overTwoTitleStyles}
  height: 100px;
  padding: 10px;
  width: 100%;
  position: relative;

  input {
    cursor: pointer;
    height: 100%;
    opacity: 0;
    position: absolute;
    width: 100%;
    z-index: 100;
  }

  .toggle-switch--group {
    background: var(--grey-2);
    border-radius: 6px;
    color: var(--titan-blue-3);
    display: block;
    font-size: var(--font-size-18);
    font-weight: var(--font-weight-500);
    height: 100%;
    position: relative;
    transition: all 0.5s ease;
    width: 100%;
    z-index: 99;
  }

  .toggle-switch--group .toggle--toggle {
    border-radius: 2px;
    display: block;
    height: calc(100% - 10px);
    left: 6px;
    position: absolute;
    top: 6px;
    transition: all 0.5s ease;
    width: ${({ twoItemToggle }) => (twoItemToggle ? '50%' : '33.33%')};
    z-index: 3;
  }

  .toggle-switch--group .toggle--toggle:before {
    align-items: center;
    background: var(--white);
    border-radius: 6px;
    bottom: 0;
    box-shadow: 0 3px 6px 1px rgba(160, 161, 188, 0.35);
    content: '';
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0;
    margin: auto;
    position: absolute;
    right: 0;
    top: -2px;
    transition: all 0.5s ease;
    width: auto;
  }

  &.dark .toggle-switch--group {
    background: var(--dark);

    .inactive {
      p {
        color: var(--grey-3);
      }
    }
  }

  &.active-1 .toggle--toggle {
    left: calc(50% - 6px);
  }

  &.active-2 .toggle--toggle {
    left: calc(66.66% - 6px);
  }

  .toggle--title {
    text-align: center;
    z-index: 9;
    margin: 0;
  }

  .toggle--title-container {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    width: 50%;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    background: transparent;
    p {
      color: var(--grey-8);
      font-size: var(--font-size-p);
      font-weight: var(--font-weight-400);
      letter-spacing: 0px;
      line-height: 150%;
      white-space: pre-wrap;
      width: 100%;
    }
    &.selected {
      p.toggle--title {
        color: var(--titan-blue-3) !important;
        &:hover {
          color: var(--titan-blue-3) !important;
        }
      }
    }
  }

  .toggle--titles {
    height: 100%;
    display: flex;

    &:hover {
      cursor: pointer;
    }
  }

  .dropdown-select--container {
    display: flex;
    justify-content: center;
  }

  @media (max-width: 575px) {
    &.open {
      .toggle--toggle {
        height: 60px !important;
      }
    }
    .toggle--title {
      padding: 0 10px;
    }

    .toggle--title-container,
    .toggle--toggle {
      width: 50%;
      left: ${({ twoItemToggle }) => (twoItemToggle ? '6px' : '6px !important')};
    }

    width: 100%;
  }
`;

export default ToggleSwitchContainer;
